import React, { useRef, useState, useEffect } from "react";
import {
  LaptopOutlined,
  NotificationOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Layout,
  Menu,
  Col,
  Row,
  Checkbox,
  message,
  Button,
  Card,
  Spin,
} from "antd";
import "./Pages.css";
import ReactPlayer from "react-player";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useParams, useNavigate, useLocation } from "react-router";
import { Player, ReplayControl, ControlBar, BigPlayButton } from "video-react";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { Document, Page, pdfjs } from "react-pdf";
import ArticleIcon from "@mui/icons-material/Article";
import { useCourseEngagement } from "../../hooks/useUserSessionTracking";
import { BaseUrl } from "../Constants/Constants";

const Pages = () => {
  const { Header, Content, Sider } = Layout;
  const [courseName, setCourseName] = useState("");
  const [MaterialName, setMaterialName] = useState("");
  const [trainingMenu, settrainingMenu] = useState([]);
  const [loading, setLoading] = useState(false);
  const [PlayedSeconds, setPlayedSeconds] = useState("");
  const [Type, setType] = useState("");
  const [TotalDuration, setTotalDuration] = useState("");
  const [TrainingModule, setTrainingModule] = useState("");
  const [DocUrl, setDocUrl] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [learningStatus, setLearningStatus] = useState(false);
  const [isVideoNearEnd, setIsVideoNearEnd] = useState(false);
  const [isPdfLoaded, setIsPdfLoaded] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const partId = searchParams.get("partId");

  const [isPdfScrolledToBottom, setIsPdfScrolledToBottom] = useState(false);
  const handlePdfScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setIsPdfScrolledToBottom(true);
    }
  };

  let url = window.location.href;
  const { id, groupId } = useParams();
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const intervalRef = useRef(null);
  const playerRef = useRef(null);
  const currentTimeRef = useRef(PlayedSeconds);
  console.log(moduleId, "moduleId");
  // Detect if this is a career program route
  const isCareerProgram = Boolean(groupId);

  // ✅ Session tracking hook – ONLY for normal courses
  const { startTracking, sendHeartbeat, endTracking, sessionId } =
    useCourseEngagement({
      courseId: id,
      moduleId,
      moduleName: MaterialName,
      moduleType: Type,
    });

  const profileDetails = JSON.parse(localStorage.getItem("Profile"));
  const UserId = profileDetails.user_id;

  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    //   setNumPages(numPages);
  };

  const saveCurrentTime = async (currentTime, fromFunction) => {
    if (isCareerProgram || !sessionId) return; // 🚫 career program skip

    let body = {
      userId: UserId,
      trainingModuleId: moduleId,
      timeViewed: currentTime,
    };

    try {
      await axios.post(
        `${BaseUrl}course-tracker/updateTimeSpentByTrainingModuleId`,
        body,
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Error saving video time", error);
    }
  };

  //Resume last watched time (COURSE ONLY)
  useEffect(() => {
    if (isCareerProgram) return;

    let body = {
      userId: UserId,
      trainingModuleId: moduleId,
    };

    axios
      .post(`${BaseUrl}course-tracker/getOneCourseTracker`, body, {
        withCredentials: true,
      })
      .then((res) => {
        if (
          res.data.statuscode === 200 &&
          res.data.data.length &&
          res.data.data[0].time_viewed
        ) {
          const seconds = convertTimeToSeconds(res.data.data[0].time_viewed);
          setTimeout(() => {
            playerRef.current?.seekTo(seconds);
          }, 1200);
        }
      });
  }, [moduleId, isCareerProgram]);

  const [consentChecked, setConsentChecked] = useState(false);

  useEffect(() => {
    // On mount, send 'viewed' status
    const markViewed = async () => {
      let body = {};
      if (isCareerProgram) {
        body = {
          user_id: UserId,
          career_course_id: id,
          part_id: partId,
          isViewed: true,
          isChecked: consentChecked,
        };
      } else {
        body = {
          user_id: UserId,
          course_id: id,
          part_id: moduleId,
          isViewed: true,
          isChecked: consentChecked,
          completionDateTime: new Date().toISOString(),
        };
      }
      try {
        const endpoint = isCareerProgram
          ? `${BaseUrl}user-career-course-part-tracker`
          : `${BaseUrl}user-course-part-tracker`;
        await axios.post(endpoint, body, { withCredentials: true });
      } catch (e) {
        console.error(e);
      }
    };

    markViewed();
  }, [id, moduleId]);

  const handleSubmit = () => {
    let body2 = {};

    if (isCareerProgram) {
      body2 = {
        user_id: UserId,
        career_course_id: id,
        part_id: partId,
        isViewed: true,
        isChecked: consentChecked,
        completionDateTime: new Date().toISOString(),
      };
    } else {
      // ✅ Build base body without session ID first
      body2 = {
        user_id: UserId,
        course_id: id,
        part_id: moduleId,
        training_module_id: moduleId,
        isViewed: true,
        isChecked: consentChecked,
        completionDateTime: new Date().toISOString(),
      };
      
    }

    if (!consentChecked) return;
    setSubmitLoading(true);

    const markCompleted = async () => {
      try {
        let res;
        if (!isCareerProgram) {
          const endpoint = `${BaseUrl}user-course-part-tracker`;

          // ✅ mark module learning status -> for courses
          await axios.post(
            `${BaseUrl}user-module-learning/update`,
            {
              user_id: UserId,
              course_id: id,
              part_id: partId,
              training_module_id: moduleId,
              is_learning: true,
            },
            { withCredentials: true }
          );

          res = await axios.post(endpoint, body2, {
            withCredentials: true,
          });
        } else {
          //for careerprogram
          res = await axios.post(
            `${BaseUrl}career-course-parts/update-learning-status`,
            {
              module_id: moduleId,
              part_id: partId,
              user_id: UserId,
              career_course_id: id,
              learning_status: true,
            },
            { withCredentials: true }
          );
        }

        if (res.status === 200 || res.status === 201) {
          setLearningStatus(true);
          const redirectPath = isCareerProgram
            ? `/career-program/group/${groupId}/course/${id}`
            : `/courses/${id}`;

          navigate(redirectPath);
          message.success("Successfully marked as completed!");
        }
      } catch (e) {
        console.error(e);
        message.error("Failed to mark as completed");
      } finally {
        setSubmitLoading(false);
      }
    };

    markCompleted();
  };
  
  useEffect(() => {
    let body = {
      userId: UserId,
      trainingModuleId: moduleId,
    };

    const getTrackerEndpoint = isCareerProgram
      ? `${BaseUrl}career-tracker/getOneCareerTracker`
      : `${BaseUrl}course-tracker/getOneCourseTracker`;

    axios
      .post(getTrackerEndpoint, body, { withCredentials: true })
      .then((res) => {
        if (res.data.statuscode == 200) {
          if (
            res.data.data.length !== 0 &&
            res.data.data[0].time_viewed !== "" &&
            res.data.data[0].time_viewed !== null
          ) {
            let convertedTime = convertTimeToSeconds(
              res.data.data[0].time_viewed
            );
            console.log(convertedTime, "getOneCourseTracker");
            setTimeout(() => {
              if (playerRef.current) {
                setTimeout(() => {
                  playerRef.current.seekTo(convertedTime);
                }, 1400);
              } else {
                console.error("Player reference is null");
              }
            }, 1500);
          }
        }
      });
  }, [id, moduleId, isCareerProgram]);

  const convertTimeToSeconds = (timeStr) => {
    const [minutes, seconds] = timeStr.split(":").map(Number);
    return minutes * 60 + seconds;
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };


  const handleProgress = ({ playedSeconds }) => {
  const formattedTime = formatTime(playedSeconds);
  setPlayedSeconds(formattedTime);
  currentTimeRef.current = formattedTime;

  if (
    TotalDuration &&
    playedSeconds >= TotalDuration * 0.9
  ) {
    setIsVideoNearEnd(true);
  }
};

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  const handlePause = () => {
    if (isCareerProgram) return;

    clearInterval(intervalRef.current);
    saveCurrentTime(currentTimeRef.current, "pause");
    sendHeartbeat();
  };

  const handlePlay = () => {
    if (isCareerProgram) return;

    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      saveCurrentTime(currentTimeRef.current, "interval");
      sendHeartbeat();
    }, 30000);
  };

  const handleReady = () => {
    // Ready handler
  };

  console.log(currentTimeRef, "currentTimeRef");

  const handleDuration = (duration) => {
    setTotalDuration(duration);
    console.log(duration, "duration");
  };

  //End session on unmount (COURSE ONLY)
  useEffect(() => {
    return () => {
      if (!isCareerProgram && sessionId) {
        saveCurrentTime(currentTimeRef.current, "unmount");
        endTracking();
      }
    };
  }, [location.pathname, sessionId, isCareerProgram]);

  const handleVideoEnded = async () => {
    if (isCareerProgram) return;

    await saveCurrentTime(currentTimeRef.current, "ended");
    await endTracking();

    if (!partId) return;

    try {
      // ✅ Build base body without session ID first
       const body = {
        user_id: UserId,
        course_id: id,
        part_id: moduleId,
        user_session_tracking_id: sessionId,
        isViewed: true,
        isChecked: true,
        completionDateTime: new Date().toISOString(),
      };

      await axios.post(`${BaseUrl}user-course-part-tracker`, body, {
        withCredentials: true,
      });

      message.success("Course completed!");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setLoading(true);

    const body = isCareerProgram
      ? { careerCourseId: id } // correct for career program
      : { courseId: id }; // correct for normal course

    const courseEndpoint = isCareerProgram
      ? `${BaseUrl}career-course-mapping/findOne`
      : `${BaseUrl}courses/findOne`;

    axios
      .post(courseEndpoint, body, { withCredentials: true })
      .then((res) => {
        const response = res.data;

        if (response.statuscode === 200) {
          if (isCareerProgram) {
            // career program findOne response
            setCourseName(response.data.title);
          } else {
            // normal course findOne response
            setCourseName(response.data[0].course_title);
          }
        } else {
          setCourseName("");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });

    const trainingBody = isCareerProgram
      ? {
          training_module_id: moduleId,
          user_id: UserId,
        }
      : {
          training_module_id: moduleId,
          user_id: UserId,
        };

    const trainingModuleEndpoint = isCareerProgram
      ? `${BaseUrl}career-course-parts/findOneTraining`
      : `${BaseUrl}training-module/findOne`;

    axios
      .post(trainingModuleEndpoint, trainingBody, { withCredentials: true })
      .then((res) => {
        if (res.data?.statuscode === 200) {
          const data = res.data.data;

          setMaterialName(data.training_module_name);
          setTrainingModule(data.training_module);
          setType(data.training_module_type);

          if (data.training_module_type === "pdf") {
            setDocUrl(data.training_module);
          }

          // ✅ SAFE: career = user based, normal = default
          setLearningStatus(!!data.learning_status);

          // ✅ START SESSION HERE (NORMAL COURSE ONLY)
          if (!isCareerProgram && !sessionId) {
            startTracking({
              courseId: id,
              moduleId,
              moduleName: data.training_module_name,
              moduleType: data.training_module_type,
            });
          }
        } else {
          setMaterialName("Training Material Not found!");
        }
      })
      .catch((err) => {
        console.error("FindOneTraining error:", err);
      });

    // API call to get course parts - different for career program
    const partsEndpoint = isCareerProgram
      ? `${BaseUrl}career-course-parts/findAllModulesByCareerCourseId`
      : `${BaseUrl}course-parts/findAllModulesByCourseId`;

    const partsBody = isCareerProgram
      ? { career_course_id: id, user_id: UserId }
      : { courseId: id };

    axios
      .post(partsEndpoint, partsBody, { withCredentials: true })
      .then((res) => {
        let response = res.data;
        console.log(response, "course parts response");

        if (response.statuscode === 200) {
          let arr = [];

          if (isCareerProgram) {
            // Career program structure
            response.data.forEach((item) => {
              arr.push({
                key: item.key,
                label: item.label,
                time: item.time,
                type: item.type,
                icon:
                  item.type === "mp4" ? (
                    <PlayCircleOutlinedIcon />
                  ) : (
                    <ArticleIcon />
                  ),
                disabled: !item.learning_status, // <--- disabled if not learned
              });
            });
          } else {
            // Regular course structure
            response.data.forEach((item) => {
              arr.push({
                key: item.key,
                label: item.label,
                time: item.time,
                type: item.type,
                icon:
                  item.type === "mp4" ? (
                    <PlayCircleOutlinedIcon />
                  ) : (
                    <ArticleIcon />
                  ),
                disabled: false,
              });
            });
          }

          settrainingMenu(arr);
          console.log(arr, "training menu array");
        } else {
          settrainingMenu([]);
        }
      })
      .catch((err) => {
        console.log(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [moduleId, isCareerProgram]);

  const playerConfig = {
    file: {
      attributes: {
        controlsList: "nodownload",
      },
    },
  };

  const handleClick = (e) => {
    const basePath = isCareerProgram
      ? `/career-program/${id}/pages`
      : `/courses/${id}/pages`;
    navigate(`${basePath}/${e.key}?partId=${partId ?? ""}`);
  };

  return (
    <div className="Pages-main">
      {/* Breadcrumb Navigation */}
      <div className="pagesBreadcrumb">
        <span
          className="breadcrumbLink"
          onClick={(e) =>
            navigate(isCareerProgram ? `/career-program` : `/courses`)
          }
        >
          {isCareerProgram ? "Career Program" : "Courses"}
        </span>
        <ArrowForwardIosIcon className="breadcrumbArrow" />
        {courseName && (
          <>
            <span
              className="breadcrumbLink"
              onClick={(e) =>
                navigate(
                  isCareerProgram
                    ? `/career-program/group/${groupId}/course/${id}`
                    : `/courses/${id}`
                )
              }
            >
              {courseName}
            </span>
            <ArrowForwardIosIcon className="breadcrumbArrow" />
          </>
        )}
        {MaterialName && (
          <span className="breadcrumbCurrent">{MaterialName}</span>
        )}
      </div>

      <Row gutter={[24, 24]}>
        {/* Sidebar - Course Contents */}
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 6 }}
          lg={{ span: 5 }}
        >
          <Card className="pagesSidebarCard">
            <div className="pagesSidebarHeader">
              <MenuBookIcon className="pagesSidebarIcon" />
              <h2 className="pagesSidebarTitle">Course Contents</h2>
            </div>
            <div className="pagesSidebarMenu">
              <Menu
                mode="inline"
                defaultOpenKeys={["sub1"]}
                selectedKeys={moduleId ? [moduleId] : []}
                className="pagesMenu"
                onSelect={(e) => handleClick(e)}
                items={trainingMenu}
              />
            </div>
          </Card>
        </Col>

        {/* Main Content Area */}
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 18 }}
          lg={{ span: 19 }}
        >
          <Card className="pagesContentCard">
            {/* Content Header */}
            {courseName && MaterialName && (
              <div className="pagesContentHeader">
                <div
                  className={`pagesContentHeaderIcon ${
                    Type === "pdf" || Type === ""
                      ? "documentIconWrapper"
                      : Type !== "mp4"
                      ? "audioIconWrapper"
                      : ""
                  }`}
                >
                  {Type === "mp4" ? (
                    <VideoLibraryIcon className="contentTypeIcon videoIcon" />
                  ) : Type === "pdf" || Type === "" ? (
                    <PictureAsPdfIcon className="contentTypeIcon documentIcon" />
                  ) : (
                    <HeadphonesIcon className="contentTypeIcon audioIcon" />
                  )}
                </div>
                <div className="pagesContentHeaderInfo">
                  <h1 className="pagesMaterialTitle">
                    {courseName} - {MaterialName}
                  </h1>
                  <span className="pagesMaterialType">
                    {Type === "mp4"
                      ? "Video Content"
                      : Type === "pdf" || Type === ""
                      ? "Document"
                      : "Audio Content"}
                  </span>
                </div>
              </div>
            )}

            {/* Content Display */}
            {loading ? (
              <div className="pagesLoader">
                <Spin size="large" />
              </div>
            ) : (
              <>
                {Type === "mp4" ? (
                  <div className="pagesVideoContainer">
                    <div className="pagesVideoWrapper">
                      <ReactPlayer
                        ref={playerRef}
                        width="100%"
                        height="100%"
                        controls
                        config={playerConfig}
                        onDuration={handleDuration}
                        onProgress={handleProgress}
                        url={TrainingModule}
                        onPause={handlePause}
                        onPlay={handlePlay}
                        onReady={handleReady}
                        onEnded={handleVideoEnded}
                        className="pagesVideoPlayer"
                      />
                    </div>
                    {!learningStatus &&
                      (!isCareerProgram || (isCareerProgram && partId)) &&
                      isVideoNearEnd && (
                        <div className="pagesCompletionSection">
                          <Checkbox
                            checked={consentChecked}
                            onChange={(e) =>
                              setConsentChecked(e.target.checked)
                            }
                            className="pagesCompletionCheckbox"
                          >
                            I confirm that I have completed this course
                            material.
                          </Checkbox>

                          <Button
                            type="primary"
                            disabled={!consentChecked}
                            loading={submitLoading}
                            onClick={handleSubmit}
                            className="pagesSubmitButton"
                            icon={<CheckCircleIcon />}
                          >
                            {submitLoading
                              ? "Processing..."
                              : "Mark as Completed"}
                          </Button>
                        </div>
                      )}
                  </div>
                ) : Type === "audio" ||
                  Type === "mp3" ||
                  (Type !== "pdf" && Type !== "" && Type !== "mp4") ? (
                  <div className="pagesAudioContainer">
                    <div className="pagesAudioWrapper">
                      <div className="pagesAudioPlayerContainer">
                        <ReactPlayer
                          ref={playerRef}
                          width="100%"
                          height="60px"
                          controls
                          config={playerConfig}
                          onDuration={handleDuration}
                          onProgress={handleProgress}
                          url={TrainingModule}
                          onPause={handlePause}
                          onPlay={handlePlay}
                          onReady={handleReady}
                          className="pagesAudioPlayer"
                        />
                      </div>
                    </div>
                    {/* Show for regular courses (always) OR career programs (only with partId and not completed) */}
                    {!learningStatus &&
                      (!isCareerProgram || (isCareerProgram && partId)) && (
                        <div className="pagesCompletionSection">
                          <Checkbox
                            checked={consentChecked}
                            onChange={(e) =>
                              setConsentChecked(e.target.checked)
                            }
                            className="pagesCompletionCheckbox"
                          >
                            I confirm that I have completed this course
                            material.
                          </Checkbox>

                          <Button
                            type="primary"
                            disabled={!consentChecked}
                            loading={submitLoading}
                            onClick={handleSubmit}
                            className="pagesSubmitButton"
                            icon={<CheckCircleIcon />}
                          >
                            {submitLoading
                              ? "Processing..."
                              : "Mark as Completed"}
                          </Button>
                        </div>
                      )}
                  </div>
                ) : (
                  <div className="pagesDocumentContainer">
                    {DocUrl !== "" ? (
                      <>
                        <div
                          className="pagesDocumentWrapper"
                          onScroll={isPdfLoaded ? handlePdfScroll : undefined}
                          style={{
                            overflowY: isPdfLoaded ? "auto" : "hidden",
                            pointerEvents: isPdfLoaded ? "auto" : "none",
                          }}
                        >
                          {!isPdfLoaded && (
                            <div className="pagesPdfLoader">
                              <Spin size="large" />
                              <p>Loading document…</p>
                            </div>
                          )}
                          <Worker
                            workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`}
                          >
                            <Viewer
                              fileUrl={DocUrl}
                              onDocumentLoad={() => {
                                setIsPdfLoaded(true);
                              }}
                            />
                          </Worker>
                        </div>

                        {/* Show for regular courses (always) OR career programs (only with partId and not completed) */}
                        {isPdfScrolledToBottom &&
                          !learningStatus &&
                          (!isCareerProgram || (isCareerProgram && partId)) && (
                            <div className="pagesCompletionSection">
                              <Checkbox
                                checked={consentChecked}
                                onChange={(e) =>
                                  setConsentChecked(e.target.checked)
                                }
                                className="pagesCompletionCheckbox"
                              >
                                I confirm that I have completed this course
                                material.
                              </Checkbox>

                              <Button
                                type="primary"
                                loading={submitLoading}
                                disabled={!consentChecked}
                                onClick={handleSubmit}
                                className="pagesSubmitButton"
                                icon={<CheckCircleIcon />}
                              >
                                {submitLoading
                                  ? "Processing..."
                                  : "Mark as Completed"}
                              </Button>
                            </div>
                          )}
                      </>
                    ) : (
                      <div className="pagesLoader">
                        <Spin size="large" />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Pages;
